/* eslint-disable */
import { Component } from 'react';
import { FieldPlayer } from 'Components'
import { _, Utils } from 'Helpers'

class SpaceAroundRow extends Component {
  render() {
    const _LineupList = _.orderBy(
      this.props.LineupList,
      function (o) {
        return new Number(o.rank);
      },
      ['asc']
    )
    const {homeView} = this.props
    // console.log(this.props,'zoom: 84%;')
    return (
      <>
        {
          this.props.is_single_player ?
            <div {...{ className: `team-row-wrap ${this.props.className}` }}>
              {_.map(
                this.props.LineupList,
                (item, idx) => {
                  if (!_.isUndefined(this.props.position) && (Utils.PlayerPositionCheck(item.position, this.props.ALL_POSITION_CLONE[this.props.SelectedWeek]) == this.props.position)) {
                    return (
                      <FieldPlayer key={idx} item={this.props.getPlayerItem(item)} getPlayerItem={this.props.getPlayerItem(item)} isDefault={_.isNull(item.player_uid)} {...this.props} />
                    )
                  }
                  if (_.isUndefined(this.props.position)) {
                    return (
                      <FieldPlayer key={idx} item={this.props.getPlayerItem(item)} getPlayerItem={this.props.getPlayerItem(item)} isDefault={_.isNull(item.player_uid)} {...this.props} />
                    )
                  }
                })}
            </div>
            :
            this.props.contestData.sports_id == 15 ?
            (() => {
              // For motorsports, handle row-based filtering
              if (!this.props.is_bench_player) {
                // Get all field players of the current position, sorted by rank
                const positionPlayers = _.orderBy(
                  this.props.LineupList.filter(p => 
                    (!p.is_bench_player || p.is_bench_player == 0) && p.position === this.props.position
                  ),
                  ['rank'],
                  ['asc']
                );
                
                // Determine which players to show for this row
                let playersToShow = [];
                if (typeof this.props.rowIndex !== 'undefined') {
                  const startIdx = this.props.startIndex || 0;
                  const maxPlayers = this.props.maxPlayers || positionPlayers.length;
                  playersToShow = positionPlayers.slice(startIdx, startIdx + maxPlayers);
                } else {
                  // If no rowIndex, show all players of this position
                  playersToShow = positionPlayers;
                }
                
                return (
                  <div className={`team-row ${this.props.className} ${this.props.is_bench_player ? 'bench-space-around' : ''}`}>
                    <div className="space-around ">
                      {playersToShow.map((item, idx) => (
                        <FieldPlayer 
                          key={idx} 
                          item={this.props.getPlayerItem(item)} 
                          getPlayerItem={this.props.getPlayerItem(item)} 
                          isDefault={_.isNull(item.player_uid)} 
                          {...this.props} 
                        />
                      ))}
                    </div>
                  </div>
                );
              } else {
                // Handle bench players normally
                return (
                  <div className={`team-row ${this.props.className} ${this.props.is_bench_player ? 'bench-space-around' : ''}`}>
                    <div className="space-around ">
                      {_.map(
                        _.orderBy(this.props.LineupList, ['bench_order'], ['asc']),
                        (item, idx) => {
                          if (item.is_bench_player && (item.is_bench_player == this.props.is_bench_player)) {
                            return (
                              <FieldPlayer key={idx} item={this.props.getPlayerItem(item)} getPlayerItem={this.props.getPlayerItem(item)} isDefault={_.isNull(item.player_uid)} {...this.props} benchClass={'pos-caption'}/>
                            )
                          }
                          return null;
                        })}
                    </div>
                  </div>
                );
              }
            })()
            :
            <div className={`team-row ${this.props.className} ${this.props.is_bench_player ? 'bench-space-around' : ''}`}>
              <div className="space-around ">
                {_.map(
                  _.orderBy(this.props.LineupList, ['bench_order'], ['asc']),
                  (item, idx) => {
                    if ((!item.is_bench_player || item.is_bench_player == 0) && (item.position == this.props.position)) {
                      return (
                        <FieldPlayer key={idx} item={this.props.getPlayerItem(item)} getPlayerItem={this.props.getPlayerItem(item)} isDefault={_.isNull(item.player_uid)} {...this.props} />
                      )
                    }
                    if (item.is_bench_player && (item.is_bench_player == this.props.is_bench_player)) {
                      return (
                        <FieldPlayer key={idx} item={this.props.getPlayerItem(item)} getPlayerItem={this.props.getPlayerItem(item)} isDefault={_.isNull(item.player_uid)} {...this.props} benchClass={'pos-caption'}/>
                      )
                    }
                  })}
              </div>
              {/* {homeView? '':<div>
                {this.props.position == "GK" && <div className='tac'>Goal Keeper</div>}
                {this.props.position == "DF" && <div className='tac'>Defenders</div>}
                {this.props.position == "MF" && <div className='tac'>Midfielders</div>}
                {this.props.position == "FW" && <div className='tac'>Forward</div>}
              </div>} */}
            </div>
        }
      </>
    )
  }
}
SpaceAroundRow.defailtProps = {
  position: null,
  className: ''
}
export default SpaceAroundRow;